import Vue                        from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path     : "/Home",
        name     : "Home",
        component: () => import(/* webpackChunkName: "Core" */ "../views/Home.vue"),
        alias    : "/"
    },
    {
        path     : "/privacy",
        name     : "Privacy",
        component: () => import(/* webpackChunkName: "Core" */ "../views/Privacy.vue")
    },
    {
        path     : "/plugin-test",
        name     : "PluginTest",
        component: () => import(/* webpackChunkName: "Core" */ "../views/PluginTest.vue")
    },
    {
        path     : "/loading",
        name     : "Loading",
        component: () => import(/* webpackChunkName: "Core" */ "../components/LoadingIndicator.vue")
    },
    {
        path     : "/manage",
        name     : "",
        component: () => import(/* webpackChunkName: "Manage" */ "../views/manage/Manage.vue"),
        children : [{
            path     : "",
            name     : "Overview",
            component: () => import(/* webpackChunkName: "Manage" */ "../views/Privacy.vue")
            //meta:{requiresAuth:true}
        }],
        meta:{requiresAuth:true}
    },
    {
        path     : "/login",
        name     : "Login",
        component: () => import(/* webpackChunkName: "Manage" */ "../views/auth/Login.vue")
    },
    {
      path     : "/unite",
      component: () => import(/* webpackChunkName: "Unite" */ "../views/unite/Unite.vue"),
      children : [{
        path     : ":eventId/:pageName?/:contributionId?",
        name     : "UnitePage",
        component: () => import(/* webpackChunkName: "Unite" */ "../views/unite/UnitePage.vue"),
        props    : true,
      }]
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to,from,next)=> {
    if (to.matched.some(m => m.meta.requiresAuth)) {
        next({
            name : "Login",
            query: {redirect: to.fullPath}
        });

    } else {
        next();
    }
});

export default router;
